import { render } from "./resendEmail.vue?vue&type=template&id=2e158c26&scoped=true"
import script from "./resendEmail.vue?vue&type=script&lang=js"
export * from "./resendEmail.vue?vue&type=script&lang=js"

import "./resendEmail.vue?vue&type=style&index=0&id=2e158c26&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e158c26"]])

export default __exports__